
define([
    'jquery',
    'velocity'
],  function ($, velocity) {

    function DPOpenClose(currentElement, options) {
        this.container = currentElement;
        this.blocks = null;
        this.namespace = 'dpopenclose';

        this._applySettings(this._defaultSettings, options);

        this.init();
    }

    DPOpenClose.prototype = {

        _defaultSettings: {
            opener: '.opener',
            classOpened: 'opened',
            contentBlock: '.content-block',
            duration: 300 // ms
        },

        init: function() {
            this._cacheElements();
            this._bindEvents();

            this._setInitState();
        },

        _cacheElements: function() {
            this.controller = this.container.find(this.opener).first();
            this.contentElement = this.container.find(this.contentBlock).first();
        },

        _bindEvents: function() {
            this.controller.on('click.'+ this.namespace, $.proxy(this._onControllerClick, this));
        },

        _unbindEvents: function() {
            this.controller.off('.' + this.namespace);
        },

        _setInitState: function() {
            if (this.container.hasClass(this.classOpened)) {
                this.openBlock();
            }else {
                this.closeBlock();
            }
        },

        _onControllerClick: function(event) {
            event.preventDefault();

            if (this.container.hasClass(this.classOpened)) {
                this.closeBlock();
            }else {
                this.openBlock();
            }
        },

        openBlock: function() {
            var blockHeight = this.contentElement[0] ? this.contentElement[0].scrollHeight : 0,
                self = this;

            $(this.opener).attr('aria-expanded', 'true');
            this.contentElement.attr('aria-hidden', 'false');
            if (this.container.tabIndex = -1) {
                this.contentElement.attr('tabindex', '').find("a, input, button").attr("tabindex", "");
            }

            this.contentElement.velocity({
                height: blockHeight
            }, {
                duration: this.duration,
                begin: function() {
                    self.container.addClass(self.classOpened);
                },
                complete: function(element) {
                    $(element).css({
                        height: 'auto'
                    });
                    self.container.trigger('openBlock', self.container, $(element));
                }
            });

            var firstElement = true;
            this.contentElement.find("a, input, button").each(function(index, value) {
                var tiv = $(this).data("tabindex");
                if (typeof tiv != "undefined") {
                    $(this).attr("tabindex", tiv);
                    if (firstElement) {
                        firstElement = false;
                        $(this).focus();
                    }
                }
            });
        },

        closeBlock: function() {
            var self = this;

            $(this.opener).attr('aria-expanded', 'false');
            this.contentElement.attr('aria-hidden', 'true').attr('tabindex', '-1').find("a, input, button").attr("tabindex", "-1");

            this.contentElement.velocity({
                height: 0
            },{
                duration: this.duration,
                begin: function() {
                    self.container.removeClass(self.classOpened);
                },
                complete: function(element) {
                    self.container.trigger('closeBlock', self.container, $(element));
                }
            });
        },

        _openImmediately: function() {
            this.contentElement.height('auto');
        },

        destroy: function() {
            this._openImmediately();
            this._unbindEvents();
        },

        _applySettings: function(defaultSettings, settings) {
            var self = this;

            settings = $.extend(defaultSettings, settings);

            $.each(settings, function(setting) {
                self[setting] = settings[setting];
            });
        },

        constructor: DPOpenClose
    };

    $.fn.dpOpenClose = function(options) {
        return this.each(function() {
            var currentElement = $(this);
            currentElement.data('dpOpenClose', new DPOpenClose(currentElement, options));
        });
    };

    return DPOpenClose;

});
